/**
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 4/10/13
 * Time: 4:19 PM
 */

/*
 The ContentsystemModel - the mother of all models
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var systemMessageConfig = require("content-config/systemMessageConfig.json");
    var systemMessageMacrosConfig = require("content-config/systemMessageMacrosConfig.json");
    var CONST = require("const");

    var ContentSystemUtilities;
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {
        ContentSystemUtilities = {

            isTimerAllowed: function (systemMessageId) {
                if (this._validateConfigExists(systemMessageId)) {
                    return systemMessageConfig.Events[systemMessageId].timer;
                } else{
                    return false;
                }
            },
            isEnabledEditable: function (systemMessageId) {
                if (this._validateConfigExists(systemMessageId)) {
                    return systemMessageConfig.Events[systemMessageId].activeEditable;
                } else{
                    return false;
                }
            },
            macros: function (systemMessageId) {
                var macros = [];
                if (this._validateConfigExists(systemMessageId)) {
                    var macroIds = systemMessageConfig.Events[systemMessageId].macros;
                    macros = _.map(macroIds,function(id){
                        if(_.isUndefined(systemMessageMacrosConfig.macros[id])){
                            LEContent.logger.graph({name: "content:ContentSystemUtilities:macrosUndefined"});
                            LEContent.logger.error("Macro value for macro ID: '" + id + "' is undefined", "ContentSystemUtilities:macros");
                        }
                        return {id: id, value: systemMessageMacrosConfig.macros[id]};
                    },this);
                }

                return macros;
            },
            allAvailableMacroValues: function(){
                var macroIds = _.keys(systemMessageMacrosConfig.macros);
                var macros = _.map(macroIds,function(id){
                        return {id: id, value: systemMessageMacrosConfig.macros[id]};
                    },this);

                return macros;
            },
            isMessageDiscontinued: function (systemMessageId) {
                if (this._validateConfigExists(systemMessageId)) {
                    return systemMessageConfig.Events[systemMessageId].discontinued;
                } else{
                    return true;
                }
            },
            saveEmptyTooltip: function(){
                return systemMessageConfig.SaveTooltip.empty;
            },
            saveNoChangesTooltip: function () {
                return systemMessageConfig.SaveTooltip.noChanges;
            },
            getHeaderTexts: function(isOnHold) {
                var mode = isOnHold?"editOnHold":"edit";
                return systemMessageConfig.contentHeader[mode];
            },
            saveContentMessageLengthTooltip: function () {
                return systemMessageConfig.SaveTooltip.msgMaxLength;
            },
            _validateConfigExists: function (systemMessageId) {
                if (_.isUndefined(systemMessageConfig.Events[systemMessageId])) {
                    LEContent.logger.graph({name: "content:ContentSystemUtilities:_validateConfigExists:systemMessageIdUndefined" });
                    LEContent.logger.error("Configuration for system message: '" + systemMessageId + "' is undefined", "ContentSystemUtilities:validateConfigExists");
                    return false;
                } else {
                    return true;
                }
            }
        };
    });

    return ContentSystemUtilities;
});
